var _path, _path2, _path3, _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrencyDiagr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 192,
    viewBox: "0 0 480 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 67.1037L0 92.5585V192H480V47.0282C478.251 46.335 475.705 46.1035 474.624 46.0492C466.207 45.6267 461.379 49.6567 454.656 53.3919L454.573 53.4384C452.585 54.5434 447.614 57.3081 438.528 57.3081C429.312 57.3081 422.912 54.6973 420.864 53.3919L390.144 32.8323C386.048 30.2215 377.088 25 367.104 25C357.12 25 349.184 30.2215 345.6 32.8323L203.52 120.461C201.216 122.093 194.15 125.356 184.32 125.356C174.49 125.356 167.424 122.093 165.12 120.461L82.944 64.6561C80.128 62.6981 71.8848 58.7819 61.44 58.7819C50.9952 58.7819 41.728 64.3298 38.4 67.1037Z",
    fill: "url(#paint0_linear_0_1)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 67.1037L0 92.5585V192H480V47.0282C478.251 46.335 475.705 46.1035 474.624 46.0492C466.207 45.6267 461.379 49.6567 454.656 53.3919L454.573 53.4384C452.585 54.5434 447.614 57.3081 438.528 57.3081C429.312 57.3081 422.912 54.6973 420.864 53.3919L390.144 32.8323C386.048 30.2215 377.088 25 367.104 25C357.12 25 349.184 30.2215 345.6 32.8323L203.52 120.461C201.216 122.093 194.15 125.356 184.32 125.356C174.49 125.356 167.424 122.093 165.12 120.461L82.944 64.6561C80.128 62.6981 71.8848 58.7819 61.44 58.7819C50.9952 58.7819 41.728 64.3298 38.4 67.1037Z",
    fill: "#390096",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 72.5585L38.4 47.1037C41.728 44.3298 50.9952 38.7819 61.44 38.7819C71.8848 38.7819 80.128 42.6981 82.944 44.6561L165.12 100.461C167.424 102.093 174.49 105.356 184.32 105.356C194.15 105.356 201.216 102.093 203.52 100.461L345.6 12.8323C349.184 10.2215 357.12 5 367.104 5C377.088 5 386.048 10.2215 390.144 12.8323L420.864 33.3919C422.912 34.6973 429.312 37.3081 438.528 37.3081C447.744 37.3081 452.727 34.4637 454.656 33.3919C461.379 29.6567 466.207 25.6267 474.624 26.0492C475.705 26.1035 478.251 26.335 480 27.0282",
    stroke: "#FF868D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 367.5,
    cy: 4.5,
    r: 4,
    fill: "#563EAF",
    stroke: "#FF868D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 38.5,
    r: 4,
    fill: "#563EAF",
    stroke: "#FF868D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 240,
    y1: 43.5,
    x2: 240,
    y2: 171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374892,
    stopColor: "white",
    stopOpacity: 0.536458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6091,
    stopColor: "white",
    stopOpacity: 0.269957
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766012,
    stopColor: "white",
    stopOpacity: 0.151176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyDiagr);
export default __webpack_public_path__ + "static/media/currency-diagr.e4ddfc011ea2bd0d0ce4b635fb12fac7.svg";
export { ForwardRef as ReactComponent };